var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('u-file-input-outlined-pill', _vm._b({
    staticClass: "v-text-field--label-inner",
    scopedSlots: _vm._u([_vm._l(_vm.$slots, function (_, slotName) {
      return {
        key: slotName,
        fn: function () {
          return [_vm._t(slotName)];
        },
        proxy: true
      };
    })], null, true)
  }, 'u-file-input-outlined-pill', _vm.$attrs, false));

}
var staticRenderFns = []

export { render, staticRenderFns }